import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldScreensRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-screens',
	path: '/jira/settings/issues/screens',
};
